define('i19n/strings',[],function () {

    ko.validation.localize({
        required: 'This field is required.',
        min: 'Please enter a value greater than or equal to {0}.',
        max: 'Please enter a value less than or equal to {0}.',
        minLength: 'Please enter at least {0} characters.',
        maxLength: 'Please enter no more than {0} characters.',
        pattern: 'Please check this value.',
        step: 'The value must increment by {0}',
        email: 'This is not a valid email address',
        date: 'Please enter a proper date',
        dateISO: 'Please enter a proper date',
        number: 'Please enter a number',
        digit: 'Please enter a digit',
        phoneUS: 'Please specify a valid phone number',
        equal: 'Values must equal',
        notEqual: 'Please choose another value.',
        unique: 'Please make sure the value is unique.'
    });

    return {
        root: {
            to: {
                NA: "N/A",
                _daysleftinyourfreetrial: "{0} days left in your free trial.",
                _documentscopiedtothedocument: "{0} Documents Copied to the Document Clipboard",
                _documentsselectedfordetailexport: "{0} documents selected for Detail Export",
                _documentstatus: "{0} Document Status",
                _isrequired: "{0} is required.",
                _usersinuse_guestsinuse: "{0} users in use / {1} guests in use",
                _usersinuseof_available: "{1} users ({0} in use) / {3} guests ({2} in use)",
                accesscontrol: "Access Control",
                account: "Account",
                accountdetails: "Account Details",
                actions: "Actions",
                actionsarenotavailabletoguestusers: "Actions are not available to Guest users.",
                addanoptionalmessage: "Add an optional message",
                adddocument: "Add Documents",
                adddocuments: "Add Documents",
                adddocumentstotheaccount: "Add documents to the Account folder in ...",
                added: "Added",
                addfieldvalue: "Add Field Value",
                addfilesasnewdocuments: "Add files as new documents to the currently selected folder",
                addflaggeddocuments: "Add Flagged Documents",
                adding: "Adding",
                additionaluser: "Additional User",
                addlistitem: "Add List Item",
                addorganisation: "Add Organisation",
                addpeople: "Add People",
                addperson: "Add Person",
                addselecteddocument: "Add Selected Document",
                addselectedpeople: "Add Selected People",
                addteam: "Add Team",
                addteamsandorpeoplethenassign: "Add Teams and/or People then assign an appropriate level of access. Users that are members of more than one team will be granted the highest level of access assigned. Deny Access however supersedes all other access granted to a user.",
                all: "All",
                allcheckedoutdocuments: "All Checked Out Documents",
                alldeleteddocuments: "All Deleted Documents",
                alldocumentshares: "All Document Shares",
                alldocumentswillbe: "All documents will be stored in the selected Repository",
                alldocumentswillbe1: "Existing documents will remain in the same Repository",
                alldocumentswillbe2: "New Repositories can be configured in Settings",
                allfiletypes: "All File Types",
                allrequests: "All Requests",
                allshares: "All Shares",
                allsharingofdocumentswith: "all sharing of documents with others",
                alluploadrequestofdocumentswith: "all upload requests of documents with others",
                alluploadrequests: "All Upload Requests",
                alluploads: "All Uploads",
                allversionofthisdocuments: "All Versions of This Document",
                amount: "Amount",
                anerrorhasoccuredpleasetryagain: "An error has occured. Please try again.",
                appversion: "App Version",
                archivedate: "Archive Date",
                archiving: "Archiving",
                areyousureyouwanttocancelthecheckoutforthedocumentsselected: "Are you sure you want to cancel the check out for the document/s selected?",
                areyousureyouwanttodeletethedocumentselected: "Are you sure you want to delete the document/s selected?",
                areyousureyouwanttomodifythefieldsofthedocumentsselected: "Are you sure you want to modify the fields of the document/s selected?",
                areyousureyouwanttoreplacethecurrentrevisionwiththepriorrevisionselected: "Are you sure you want to replace the current revision with the prior revision selected? This action cannot be undone",
                areyousureyouwanttoundeletethedocumentsselected: "Are you sure you want to undelete the document/s selected?",
                assignedto: "Assigned To",
                assignto: "Assign To",
                attachment: "Attachment",
                attachments: "Attachments",
                auditing: "Auditing",
                author: "Author",
                availablefields: "Available Fields",
                availablelistcolumns: "Available List Columns",
                backtologin: "Back to login",
                basedon: "Based On",
                bcc: "BCC",
                bulkchangeafieldsetting: "Bulk change a field setting",
                bulkchangesfieldsetting: "Bulk changes field setting",
                cancel: "Cancel",
                cancelcheckout: "Cancel Check Out",
                canceltrial: "Cancel Trial",
                canceltrialsubscription: "Cancel Trial Subscription",
                caneditlistvalues: "Can Edit List Values",
                cannotdelete: "This Library cannot be deleted as it contains documents.",
                cannotdeletefolder: "Cannot delete folder",
                cannotdeletefolderbecauseitcontainsdeleted: "Cannot delete folder because it contains deleted documents. Would you like to purge these documents?",
                cannotempty1: "This Library cannot be emptied as one or more documents are checked-out.",
                cannotempty2: "This Library cannot be emptied as the Library has not been disabled in Library settings",
                cantadddocument: "Can't Add Document",
                category: "Category",
                cc: "CC",
                changepassword: "Change Password",
                changetoa: "Change to a",
                changetocontrolled: "Change to Controlled",
                checkedout: "Checked Out",
                checkedoutby: "Checked Out By",
                checkedoutdocuments: "Checked Out Documents",
                checkin: "Check In",
                checkingthisboxwillmakeallcontrolleddocumentswithapublish: "Checking this box will make all Controlled documents with a Status of Published available on the Add Documents page.",
                checkout: "Check Out",
                checkoutandopen: "Check Out and Open",
                checkoutselecteddocuments: "Check Out Selected Document/s",
                checkoutwithopening: "Check Out with opening",
                checkoutwithoutopening: "Check Out without opening",
                chooseadocdate: "Choose a doc date",
                chooseadoctype: "Choose a doc type",
                choosealocation: "Choose a location",
                chooseanauthor: "Choose an author",
                chooseanindex: "Choose an index",
                chooseaperiod: "Choose a period",
                chooseareviewer: "Choose a reviewer",
                chooseassignto: "Choose assign to",
                chooseayear: "Choose a year",
                choosecategory: "Choose category",
                chooselastrevieweddate: "Choose last reviewed date",
                choosenextreviewdate: "Choose next review date",
                choosereviewer: "Choose reviewer",
                choosethedocumentstatus: "Choose the document status",
                choosetheperson: "Choose the person responsible",
                clearaccesscontrol: "Clear Access Control",
                click: "Click",
                close: "Close",
                codecolumntitle: "Code Column Title",
                columns: "Columns",
                columnsettings: "Column Settings",
                columnstodisplay: "Columns to Display",
                confirm: "Confirm",
                confirmcancellation: "Confirm Cancellation",
                confirmdelete: "Confirm Delete",
                confirmpassword: "Confirm Password",
                confirmremove: "Confirm Remove",
                contactus: "Contact us",
                continue: "Continue",
                controlled: "Controlled",
                copy: "Copy",
                copydocuments: "Copy Documents",
                copydocumentshere: "Copy Documents Here",
                copythe_documenttemplatesinto: "Copy the {0} document templates into",
                copytheselecteddocumentsinto: "Copy the selected documents into a different folder.",
                create: "Create",
                createanduseanewlistcalled_asdefinedinthisblueprint: "Create and use a new List called {0} as defined in this blueprint",
                createanewdocumentbasedonthisdocumentinwindows: "Create a new document based on this document in Windows.",
                createanewemptylibraryusingthe: "Create a New Empty Library Using the {0}",
                createanewemptylibraryusingtheblueprint: "Create a New Empty Library Using the {0} Blueprint",
                createanewemptylibraryusingtheblueprint2: "",
                createanewemptylibraryusingtheblueprint3: "Fields: {0}",
                createanewemptylibraryusingtheblueprint4: "List: {0}",
                createanewemptylibraryusingtheblueprint5: "Folder Template: {0}",
                createanewlibraryfromfolder: "Create a New Library From Folders On Your Computer",
                createanewlibraryfromfolder2: "Use the fileplan Windows application to select a folder and subfolders from your Windows file system and have the same folder structure created in fileplan.",
                createanewlibraryfromfolder3: "Documents in each Windows folder can be optionally imported as part of the Create from Folders process. You can also nominate the first level of sub-folders to be converted into a fileplan list.",
                createanewlibraryfromscratch: "Create a New Empty Library from Scratch",
                createanewlibraryfromscratch2: "You decide the Library Name, and whether or not your new Library will use an existing List.",
                createanewlibraryfromscratch3: "Use this option if none of the Blueprints available meet your needs.",
                created: "Created",
                createdby: "Created By",
                createdormodifiedby: "Created or Modified by",
                createfoldertemplate: "Create Folder Template",
                createfromfolder: "Create From Folder",
                createfromscratch: "Create From Scratch",
                createlibrary: "Create Library",
                createversion: "Create Version",
                culture: "Culture",
                current: "Current",
                currentversion: "Current Version",
                dashboard: "Dashboard",
                daterange: "Date Range",
                days: "Days",
                defaultrepository: "Default Repository",
                delete: "Delete",
                deleted: "Deleted",
                deleteddocuments: "Deleted Documents",
                deletefolder: "Delete Folder",
                deletelibrary: "Delete Library",
                deletelist: "Delete List",
                deleteselecteddocuments: "Delete Selected Document/s",
                denyaccess: "Deny Access",
                desccolumntitle: "Desc Column Title",
                description: "Description",
                destructiondate: "Destruction Date",
                details: "Details",
                disablethislibrary: "Disable this Library",
                disablingthislibrarywill: "Disabling this Library will immediately stop users saving or changing documents in this Library. The Library will also be disabled for searching and retrieving documents.",
                discoverable: "Discoverable",
                dispatchdate: "Dispatch Date",
                display: "Display",
                displayfields: "Display Fields",
                displayname: "Display Name",
                docdate: "Doc Date",
                docid: "Doc Id",
                docidversion: "Version",
                docs: "Docs",
                docstatus: "Doc Status",
                doctype: "Doc Type",
                documentactionerrors: "Document Action - Errors",
                documentcontrol: "Document Control",
                documentcontrolstatus: "Document Control Status",
                documentlinks: "Document Links",
                documents: "Documents",
                documentsarenotversionedcontrolled: "documents are not versioned controlled.",
                documentsbyclass: "Documents by Class",
                documentscopiedtodocumentclipboardnavigatetocopy: "Documents copied to document clipboard. Navigate to a folder to copy the documents.",
                documentscopiedtodocumentclipboardnavigatetomove: "Documents copied to document clipboard. Navigate to a folder to move the documents.",
                documentspurged: "Documents Purged",
                documentsselectedforsharingwith: "Documents selected for sharing with:",
                documentstatus: "Document Status",
                documentstatusupdated: "Document Status Updated",
                documenttomakethisversion_: "document to make this version {0}.",
                done: "Done",
                doneyournewlibraryis: "Done, your new Library is nearly ready",
                donotmakeacopyofthesedocuments: "Do not make a copy of these documents.",
                donotpurge: "Do not purge.",
                donotselectdocumentsinserver: "Do not Select Documents in Server",
                dontcancel: "Don't Cancel",
                dontuseanytemplatedocumentsinthenewfoldertemplate: "Do not use any template documents in the new Folder Template",
                dotnotmovethedocuments: "Do not move the documents.",
                download: "Download",
                downloaded: "Downloaded",
                downloads: "Downloads",
                dragacolumnfromavailablefieldslisttoincludefieldslistin: "Drag a column from Available Fields list to Include Fields list in order to include it as right-most column in the list of document. Drag the Included Fields up and down to adjust the right-to-left column order ",
                dragcolumnnamestoaddorremovefromthelistdisplay: "Drag column names to add or remove from the List display. The top column will be the left most column displayed.",
                drophere: "Drop here",
                duplicateanexistinglibrary: "Duplicate An Existing Library to Create a New Empty Library",
                duplicateanexistinglibrarytocreateanewemptylibrary: "Duplicate An Existing Library to Create a New Empty Library",
                duplicateanexistinglibrarytocreateanewemptylibrary2: "Use this option if you want a Library with an identical configuration to an existing Library.",
                duplicateanexistinglibrarytocreateanewemptylibrary3: "These things will all be the same:",
                duplicateanexistinglibrarytocreateanewemptylibrary3a: "List (if a List is used, this can't be changed)",
                duplicateanexistinglibrarytocreateanewemptylibrary3b: "Folder Template (this can be changed later)",
                duplicateanexistinglibrarytocreateanewemptylibrary3c: "Access Control settings for the Library and List values (this can be changed later).",
                duplicateanexistinglibrarytocreateanewemptylibrary4: "You get to decide the Library Name and Default Repository",
                duplicateasversion_: "Duplicate as Version {0}",
                duplicateexisting: "Duplicate Existing",
                duplicateversion_asversion_: "Duplicate version {0} as version {1}?",
                eachvalueinthe: "Each value in the selected List will have one or more folders in which documents will be stored.",
                edit: "Edit",
                editaccesscontrol: "Edit Access Control",
                editor: "Editor",
                editorganisation: "Edit Organisation",
                editperson: "Edit Person",
                eithercurrentstoragespaceuse: "Either current storage space used or number of guest users exceeds the limit of this plan",
                email: "Email",
                emailaddress: "Email Address",
                emailarequesttouploaddocuments: "Email a request to upload documents to the selected folder.",
                emailisrequired: "Email is required",
                emptylibrary: "Empty Library",
                enteradestructiondate: "Enter a destruction date",
                enteradispatchdate: "Enter a dispatch date",
                enteradocumenttitle: "Enter a document title",
                enterahyperlink: "Enter a hyperlink",
                enteranamount: "Enter an amount",
                enteranarchivedate: "Enter an archive date",
                enterdocumentnumber: "Enter document number",
                enterpath: "Enter Path",
                enterpaymentdetails: "Enter payment details",
                enterprivilegereason: "Enter privilege reason",
                entersomenotes: "Enter some notes",
                entersourcedocumentnumber: "Enter source document number",
                error: "Error",
                export: "Export",
                exportdetails: "Export Details",
                exportdocumentdetailstoexcel: "Export document details to Excel.",
                exporttocsv: "Export to CSV",
                exporttoexcel: "Export to Excel",
                ext: "Ext",
                extension: "Extension",
                extra: "Extra",
                failedtoadd: "Failed to add",
                favouritedocuments: "Favourite Documents",
                favourites: "Favourites",
                field: "Field",
                fields: "Fields",
                fieldsinthislibrary: "Fields in This Library",
                fieldvalue: "Field Value",
                fieldvalues: "Field Values",
                filedin: "Filed in",
                fileplanclientmustbeinstalledtousethisbutton: "The fileplan client must be installed to use this button.",
                fileplansetupguide: "fileplan Setup Guide",
                filetypes: "File Types",
                filterinall_: "Filter in All {0}",
                filterinmy_: "Filter in My {0}",
                filterinmyteam_: "Filter in My Team's {0}",
                filterlistitems: "Filter List Items",
                filterorganisations: "Filter Organisations",
                filterpeople: "Filter People",
                filterteams: "Filter Teams",
                finish: "Finish",
                firstname: "First Name",
                flagged: "Flagged",
                flaggeddocuments: "Flagged Documents",
                folder: "Folder",
                folderaccesscontrol: "Folder Access Control",
                folderactions: "Folder Actions",
                folders: "Folders",
                foldersanddocuments: "Folders and Documents",
                foldertemplate: "Folder Template",
                for: "For",
                for1day: "For 1 day",
                for28days: "For 28 days",
                for7days: "For 7 days",
                forever: "Forever",
                forgotpassword: "Forgot password?",
                fortheselectedfieldincludethe: "For the selected field, include the Lookup field values required for this Library.",
                fortheselectedfieldincludethelookupfieldvaluesreuiredforthislibrary: "For the selected field, include the Lookup field values required for this Library. All values will be included by default if none are ticked.",
                forward: "Forward",
                four: "4",
                freespaceavailable: "Free Space Available",
                from: "From",
                fullaccess: "Full Access",
                growthovertime: "Growth over Time",
                guest: "Guest",
                happytowaitcontinuewithselection: "Happy to wait, continue with selection.",
                hasbeenexcludedfromlibrary: "has been excluded from Library",
                hasbeenincludedinlibrary: "has been included in Library",
                help: "Help",
                helpandsupport: "Help & Support",
                here: "here",
                hideallfields: "Hide All Fields",
                highestpublishedversionlinks: "Highest Published Version Links",
                history: "History",
                howmanyextrausersrequired: "How many extra users required",
                howmanyusersdoyouneed: "How many users do you need?",
                ifthisisapublicorshareddeviceleaveunchecked: "If this is a public or shared device, leave unchecked and sign out when you're done to protect your account",
                importedfromfilepath: "Imported From File Path",
                importfromcsv: "Import from CSV",
                importfromexcel: "Import from Excel",
                include: "Include",
                includedfields: "Included Fields",
                index: "Index",
                infields: "In Fields",
                initializing: "Initializing",
                insufficientaccesscontrolprivileges: "Insufficient access control privileges.",
                insufficientrights: "Insufficient Rights",
                invalidemailaddresspleasemakesure: "Invalid email address. Please make sure the address is correct",
                isitokaytopublish: "Is Okay to Publish?",
                isrequired: " is required",
                last30days: "Last 30 Days",
                last7days: "Last 7 Days",
                last90days: "Last 90 Days",
                lastmodifiedby: "Last Modified By",
                lastname: "Last Name",
                lastreviewed: "Last Reviewed",
                lastrevieweddby: "Last Reviewed By",
                learnmore: "Learn More",
                leftmostcolumn: "Left-most column",
                libraries: "Libraries",
                library: "Library",
                librarydeleted: "Library Deleted",
                libraryemptied: "Library Emptied",
                libraryfields: "Library Fields",
                libraryname: "Library Name",
                librarytoduplicate: "Library to duplicate",
                link: "Link",
                linkeddocuments: "Linked Documents",
                list: "List",
                listaccesscontrol: "List Access Control",
                listcreated: "List Created",
                listdeleted: "List Deleted",
                listitemadded: "List Item Added",
                listitemdeleted: "List Item Deleted",
                listitemupdated: "List Item Updated",
                listname: "List Name",
                lists: "Lists",
                listupdated: "List Updated",
                listusedbythislibraries: "List used by this Libraries",
                listusedbythislibrary: "List used by this Library",
                location: "Location",
                login: "Login",
                makeacopyofthesedocumentsinthisfolder: "Make a copy of these documents in this folder.",
                manageaccount: "Manage Account",
                managesubscription: "Manage Subscription",
                markdocumentsascheckedout: "Mark documents as Checked Out.",
                markdocumentsasdeleted: "Mark document(s) as deleted",
                maxfileexceeded: "Max file exceeded",
                modifyfield: "Modify Field",
                modifyfieldselecteddocuments: "Modify Field Selected Document/s",
                mostactiveusers: "Most Active Users",
                move: "Move",
                movedocuments: "Move Documents",
                movedocumentshere: "Move Documents Here",
                movethedocumentsintothisfolder: "Move the documents into this folder.",
                movetheselecteddocumentsinto: "Move the selected documents into a different folder.",
                my: "My",
                mycheckedoutdocuments: "My Checked Out Documents",
                mydeleteddocuments: "My Deleted Documents",
                mydocumentshares: "My Document Shares",
                myrequests: "My Requests",
                myshares: "My Shares",
                mysharingofdocumentswith: "my sharing of documents with others",
                myuploadrequestofdocumentswith: "my upload request of documents with others",
                myuploadrequests: "My Upload Requests",
                myuploads: "My Uploads",
                name: "Name",
                nameteamoremailaddress: "Name, Team or Email Address",
                new: "New",
                newdocumentscanonlybeaddedtoalibrary: "New documents can only be added to a Library.",
                newfolder: "New Folder",
                newpassword: "New Password",
                next: "Next",
                nextreview: "Next Review",
                nextreviewby: "Next Review By",
                nextreviewdate: "Next Review Date",
                no: "No",
                nocategory: "No Category",
                nocontrolleddocumentsselected: "No controlled documents selected",
                nodocumentselected: "No document selected.",
                nofileplanclientfound: "No fileplan client found",
                nofoldershavebeenfavourited: "No folders have been favourited.",
                nolibrariesdefined1: "No Libraries defined",
                nolibrariesdefined2: "Click Create to make your first Library",
                nolist: "No List",
                nolistsdefined1: "No Lists defined",
                nolistsdefined2: "Click Create to make your first List",
                none: "none",
                nonecreatedyetusethesettings: "None created yet (use the Settings option once this Library is created)",
                nopeopleremaining: "No People Remaining",
                nosearchresultsfound: "No search results found.",
                notcurrent: "Not Current",
                notes: "Notes",
                notesforthisversion: "Notes for this version.",
                nothighest: "Not Highest",
                nothighestversion: "Not Highest Version",
                ok: "Ok",
                okay: "Okay",
                one: "1",
                onlyselectthedocumentscurrentlydisplayed: "Only select the documents currently displayed.",
                onlyyoutochangeuserset: "Only you (to change user Set Access Control once the Library is created)",
                open: "Open",
                openandcheckout: "Open and Check Out",
                openandcheckoutthedocumentwithitswindowsapplication: "Open and Check Out the document with its Windows application.",
                openandreadonlythedocumentwithitswindowsapplication: "Open and Read Only the document with its Windows application.",
                openreadonly: "Open Read Only",
                openthedocumentwithitswindowsapplication: "Open the document with its Windows application.",
                openwith: "Open With",
                organisation: "Organisation",
                organisationadded: "Organisation Added",
                organisationdeleted: "Organisation Deleted",
                organisations: "Organisations",
                ourdocnumber: "Our Doc No.",
                overviewandmaintenance: "overview and maintenance",
                page: "page",
                pagecount: "Page Count",
                pages: "pages",
                password: "Password",
                passwordsdonotmatch: "Passwords do not match. Please try again.",
                passwordupdated: "Password updated",
                paste: "Paste",
                pastedocuments: "Paste Documents",
                pastedocumentshere: "Paste Documents Here",
                people: "People",
                peopleaddedtoorganisation: "People added to organisation",
                peopleaddedtoteam: "People added to team",
                peopleorganisationsteams: "people, organisations and teams",
                period: "Period",
                permanentlydeletedocuments: "Permanently delete documents",
                person: "Person",
                personadded: "Person Added",
                persondeleted: "Person Deleted",
                phone: "Phone",
                pleasechoosedateandtimeof: "Please choose date and time of",
                pleasechoosedateof: "Please choose date of",
                pleaseclickdownloadinstead: "Please click Download instead",
                pleaseconfirmthatyouwanttopermanentlyremovetheselecteddocuments: "Please confirm that you want to permanently remove the selected documents. This action cannot be undone.",
                pleaseconfirmyouwishtocancel1: "Please confirm you wish to cancel this trial subscription.",
                pleaseconfirmyouwishtocancel2: "All trial users will no longer be able to access fileplan effective immediately.",
                pleaseconfirmyouwishtocancel3: "Your fileplan instance and the documents it contains will be deleted.",
                pleasecontactthesender: "Please contact the sender for more information",
                pleaseenteravalidvalue: "Please enter a valid value.",
                pleaseenterthe: "Please enter the",
                pleaseselectafolderinalibraryandtryagain: "Please select a folder in a Library and try again.",
                pleaseselectavaluefromthelist: "Please select a value from the list.",
                pleaseuploaddocuments: "Please upload documents",
                prev: "Prev",
                preview: "Preview",
                privileged: "Privileged",
                privilegereason: "Privilege Reason",
                processing: "Processing",
                profile: "Profile",
                purge: "Purge",
                purgedeleted: "Purge Deleted",
                purgeselecteddocument: "Purge Selected Document/s",
                purgethesedocuments: "Purge these documents.",
                reactivatesubscription: "Reactivate Subscription",
                readonly: "Read Only",
                readpublishedonly: "Read Published Only",
                recent: "Recent",
                recentdocuments: "Recent Documents",
                recipient: "Recipient",
                recipients: "Recipients",
                relatesto: "List Relates To",
                remove: "Remove",
                remove_fromorganisation: "Remove {0} from organisation",
                remove_fromteam: "Remove {0} from team",
                removefolder: "Remove folder",
                removethedocumentsfromthedocumentclipboardandclose: "Remove the documents from the document clipboard and close the window.",
                renamefolder: "Rename",
                replacedocumentwithnewfile: "Replace document with new file",
                replacefile: "Replace File",
                replacefileordocumentselected: "Replace the file or document selected",
                replacing: "Replacing",
                reply: "Reply",
                repository: "Repository",
                requestedby: "Requested By",
                required: "Required",
                resend: "Resend",
                resendemaildocumentsharelinkdone: "Resend email document share link done",
                resetaccesscontrolforthisfolderanditschildfoldersaccesscontrolwillbeinheritedfromthisfoldersparent: "Reset Access Control for this folder and its child folders. Access Control will be inherited from this folder's parent.",
                resetpassword: "Reset Password",
                resetpasswordemailsent: "Reset password email sent.",
                responsible: "Responsible",
                rest: "rest",
                restore: "Restore",
                restoreselecteddocument: "Restore Selected Document",
                reviewandconfirm: "Review and confirm",
                reviewby: "Review By",
                rightmostcolumn: "Right-most column",
                role: "Role",
                sameastochangeuseaccesscontrol: "Same as {0} (to change use Set Access Control once this Library is created)",
                sameastochangeusethesettingsoption: "Same as {0} (to change use the Settings option once this Library is created)",
                save: "Save",
                saveandcontinue: "Save and Continue",
                savedocumentinbrowserdownloads: "Save document in browser Downloads.",
                savenewversion: "Save New Version",
                savenewversionofdocument: "New version of document.",
                search: "Search",
                searchfor: "Search For",
                searchin: "Search In",
                select: "Select",
                selectacategory: "Select a Category",
                selectaclass: "Select a Document Class",
                selectadocumentstatus: "Select a Document Status",
                selectadocumenttype: "Select a Document Type",
                selectafield: "Select a Field",
                selectafieldtomodify: "Select a field to modify",
                selectafiletouploadandcheckin: "Select a file to upload and Check In for {0}.",
                selectafolder: "Select a Folder",
                selectalibrary: "Select a Library",
                selectalist: "Select a List",
                selectalocation: "Select a Location",
                selectandcontinue: "Select and Continue",
                selectanindex: "Select an Index",
                selectaperiod: "Select a Period",
                selectaperson: "Select a Person",
                selectapriviledgedreason: "Select a Privileged Reason",
                selectarepository: "Select a repository",
                selectatemplate: "Select a Template",
                selectayear: "Select a Year",
                selectdocuments: "Select Documents",
                selectlist: "Select List",
                selectoneormoredocuments: "Select one or more documents then select Share from Action.",
                selectthefieldstoshowonfieldspane: "Select fields to show on the Fields pane of the Details tab for this Library.",
                selectthelistuseforthislibrary: "Select the List to use for this Library",
                selectuserquantity: "Select user quantity",
                selectyourplan: "Select your plan",
                send: "Send",
                sendpasswordresetemailtouser: "Send password reset email to user",
                setaccesscontrol: "Set Access Control",
                setpassword: "Set Password",
                settings: "Settings",
                settingsforthisfileplan: "Settings for this fileplan instance",
                setupguide: "Setup Guide",
                share: "Share",
                sharedate: "Share Date",
                sharedby: "Shared By",
                sharedocumentlinkswithotherpeopleandemail: "Share document links with other People and email recipients.",
                shareexpiry: "Share Expiry",
                sharefooter: "Share Footer",
                sharelinkwillwork: "Share link will work",
                sharewithothers: "Share with others.",
                show: "Show",
                showall: "Show All",
                showall_: "Show All {0}",
                showalldocuments: "Show all documents",
                showallfields: "Show All Fields",
                showdeleted: "Show Deleted",
                showdownloadlinkstoselecteddocuments: "Show download links to selected documents",
                showmeanextstepsemail: "Send me a Next Steps email showing me what to do next",
                showmy_: "Show My {0}",
                showmyteams_: "Show My Team's {0}",
                sincelastaccessed: "Since Last Accessed",
                sincelastdocumentchanged: "Since Last Document Changed",
                sortby: "Sort By",
                sourcedocnumber: "Source Doc No.",
                spacebylibrary: "Space By Library",
                spaceused: "Space Used",
                startingatversion: "starting at version",
                stayloggedin: "Stay logged in",
                subject: "Subject",
                subjectisrequired: "Subject is required",
                submit: "Submit",
                subscription: "Subscription",
                team: "Team",
                teamadded: "Team Added",
                teamdeleted: "Team Deleted",
                teams: "Teams",
                tellmemore: "Tell me more",
                templatefolders: "Template Folders",
                textenteredherewill: "Text entered here will appear at the bottom of all Share Emails",
                textsearchable: "Text Searchable",
                the_documentscopiedtothedocumentclipboardwillbemovedintothisfolder: "The {0} documents copied to the document clipboard will be moved into this folder",
                the_documentscopiedtothedocumentclipboardwillbepastedintothisfolder: "The {0} documents copied to the document clipboard will be pasted into this folder",
                the_librarywillbedeleted1: "The {0} Library will be deleted.",
                the_librarywillbedeleted2: "This action cannot be undone.",
                the_librarywillbedeleted3: "This Library does not contain any documents",
                the_librarywillbeemptiedofalldocuments1: "The {0} Library will be emptied of all documents.",
                the_librarywillbeemptiedofalldocuments2: "This action cannot be undone. All documents will be deleted.",
                the_librarywillbeemptiedofalldocuments3: "Enter your password to continue",
                the_listincludingallthedatainthelistwillbedeleted1: "The {0} List including all the data in the List will be deleted.",
                the_listincludingallthedatainthelistwillbedeleted2: "This action cannot be undone.",
                the_listincludingallthedatainthelistwillbedeleted3: "This List is not used in any Libraries.",
                theactioncouldnotbecompletedbecause: "The action could not be completed because: ",
                theactioncouldnotbecompletedforthisdocumentbecause: "The action could not be completed for this document because: ",
                thedocumentswillbemovedtodeleteddocuments: "The document/s will be moved to Deleted documents.",
                thedocumentswillbemovedtotheiroriginallocation: "The document/s will be moved to their original location.",
                thedocumentswillbepurged: "The document/s will be purged.",
                thedocumentswillbeupdated: "The document/s will be updated.",
                thedocumentswillnolongerbecheckedout: "The document/s will no longer be Checked Out.",
                thefilefor_docwillbereplacedwith: "The file for {0} doc will be replaced with the uploaded file. The Title will not be changed.",
                thefollowingdocumentswillbecopiedintothisfolder: "The following documents will be copied into this folder:",
                thefollowingdocumentswillbemovedintothisfolder: "The following documents will be moved into this folder: ",
                thefollowingerrorsoccured: "The following errors occurred:",
                thelibrarywilluseonly: "The Library will use only Folders, no List required",
                thepriorrevisionselectedwillreplacethecurrentrevision: "The prior revision selected will replace the current revision.",
                thesedocumentdownloadlinkscanbecopiedandpastedintoofficedocumentsandothersystems: "These document download links can be copied and pasted into Office documents and other systems. The person clicking the link must have permission to access the document.",
                theselecteddocumentswillbemarkedascheckedouttoyou: "The selected document/s will be marked as Checked Out to you. Other users will not be able to edit these documents.",
                theselinkswillopenthehighestpublishedversionofacontrolleddocument: "These links will open the highest Published version of a Controlled document. These links save time as they do not need to be updated each time a new version of a Controlled document is Published.",
                theuploadedfilewillbesavedasthenextversionof_: "The uploaded file will be saved as the next version of {0}",
                thevalueenteredisinvalid: "The value entered is invalid.",
                thisdocumentwillbecheck: "This document will be checked-out to you.",
                thisdocumentwillbecheck2: "You can save changes. Nobody else can edit the document.",
                thisdocumentwillbeopen: "This document will be opened but no changes can be saved.",
                thisdocumentwillbeopen2: "You can save changes as a new document",
                thisfolderswillbeautomatically: "These folders will be automatically created when the first document is saved to a List value in this Library.",
                thisfolderswillbeautomatically1: "Any changes to this template will not be applied to existing List values.",
                thisfootercanbeeditedbyclickingshare: "This footer can be edited by clicking Share on the Settings page.",
                thisisinvalidorurlhasexpired: "Invalid or url has expired",
                thislibrarycontainstemplatedocuments: "This Library contains template documents",
                thislibrarywillusealist: "This Library will use a List",
                thislinkisnolongervalid: "This Link is no longer valid",
                thisoperationcouldtakeafewminutestocomplete: "This operations could take a few minutes to complete.",
                three: "3",
                title: "Title",
                to: "To",
                todownloadthefileplanclientforwindows: "to download the fileplan client for windows",
                todownloadthefileplanclientforwindows78learnmore: "Download the fileplan client for Windows 7,8 and 10. Learn more. (fileplan version {0})",
                toreducethetotalnumberofuserssetsomeusersto: "To reduce the total number of users, set some USERS to Non-User/Disabled",
                toreducethetotalnumberofuserssetsomegueststo: "To reduce the total number of users, set some GUESTS to Non-User/Disabled",
                toreducethetotalnumberofguestorusers: "To reduce the total number of Guests or Users, set the role to Non-user/Disabled.",
                totalspaceused: "Total Space Used",
                two: "2",
                type: "Type",
                undelete: "Undelete",
                undeleteselecteddocument: "Undelete selected documents",
                undeletetheselecteddocument: "Undelete the selected documents",
                unknown: "Unknown",
                update: "Update",
                updated: "Updated",
                upgradesubscription: "Upgrade Subscription",
                uploadadocumentandcheckin: "Upload a document and Check In",
                uploadandcheckin: "Upload and Check In",
                uploadasnextversion: "Upload As Next Version",
                uploadasversion_: "Upload as Version {0}",
                uploaddate: "Upload Date",
                uploaddocument: "Upload Document",
                uploadedby: "Uploaded By",
                uploadexpiry: "Upload Expiry",
                uploading: "Uploading",
                uploadlinkwillwork: "Upload link will work",
                uploadonefileasnextverionofdocumentselected: "Upload one file as next version of document selected",
                uploadrequest: "Upload Request",
                uploadrequestdate: "Upload Request Date",
                uploads: "Uploads",
                usage: "Usage",
                useanexistinglist: "Use an existing List",
                username: "Username",
                userscanaddeditanddeletedocuments1: "Users can add, edit and delete documents. Guest users can view existing documents but",
                userscanaddeditanddeletedocuments2: "cannot save new documents or edit existing documents. Guest users are included free of charge.",
                userscanaddeditanddeletedocuments3: "Need help? Please ",
                usersinsubscription: "Users in Subscription",
                usersintrialsubscription: "Users in Trial Subscription",
                usethefoldermenutoduplicate: "Use the folder menu to duplicate the documents in this or a different folder.",
                usethefoldermenutomove: "Use the folder menu to move the documents into a different folder.",
                version: "Version",
                versionnotes: "Version Notes",
                versionnotesupdated: "Version Notes Updated",
                versions: "Versions",
                viewdetails: "View Details",
                visiblefields: "Visible Fields",
                warning: "WARNING",
                website: "Website",
                working: "Working",
                wouldyouliketoexportdetailsforthedocument: "Would you like to export details for the document/s selected?",
                year: "Year",
                yes: "Yes",
                yestochangeusethesettingsoption: "Yes (to change use the Settings option once this Library is created)",
                youdonothaveanyshareddocuments: "You do not have any shared documents",
                yourfileplantrialhasbeencancelled1: "Your fileplan trial has been cancelled. Thank you for taking the time to try fileplan.",
                yourfileplantrialhasbeencancelled2: "We would greatly appreciate any feedback, please email",
                youroptionsare: "Your options are...",
                documentuploadrequests: "document upload requests",
                bulkdownload: "Bulk Download",
                bulkdownloadtheselecteddocuments: "Bulk download the selected documents.",
                libraryaccesscontrol: "Library Access Control",
                createnewlibrary: "Create New Library",
                useablueprint: "Use a Blueprint",
                createanewlibrarybasedononeofthepredefined: "Create a new Library based on one of the pre-defined Blueprints Library templates.",
                categories: "Categories",
                blueprints: "Blueprints",
                clicknexttocontinue: "Click Next to Continue",
                toseedocumentsyouwillselect: "To see documents you will select from a list (for example Clients, Matters or Projects), then you will see the folders for the selected list item.",
                noteifthelistyouneeddoesntexistyet: "Note, if the List you need doesn't exist yet, go to Lists and click Create.",
                addfolderstobeautomaticallycreatedunderevery: "Add folders to be automatically created under every new entry in {0}",
                ifincludeisnottickedforanywavalues: "If Include is not ticked for any values, then all values will be included by default.",                                
                theofficialchronologicaldateorderfield: "The official chronological date order field set according by admin settings.",
                thedateadocumentwasdispatched: "The date a document was dispatched, for example the date a document was posted or emailed. This field can be used to generate register of documents sent.",
                periodfieldwhichshowsyearqtrmonth: "Period field which shows year/qtr/month.",
                fourdigityear: "4 digit year.",                
                whichretentionplanifanyisapplied: "Which retention plan, if any, is applied to this doc. This is an internal code.",                
                categorizedocumentsbyorigin: "Categorize documents by origin, action required, project task, team, work type etc. Enter the Category values required below.",
                recordthetypeofdocumentsuchasletter: "Record the type of document such as Letter, Fax, Memo, Email, Report, Image, Cashflow Analysis, Board Meeting Paper, Leave Request etc. Enter the Doc Type values required below.",
                frompersontable: "From Person table.",
                fromkeywordsbuilder: "From keywords builder.",
                fromtagbuilder: "From tag builder.",                
                assignedastatustothedocumentsuchasdraft: "Assigned a status to the document such as Draft, Pending Approval, Final etc. Enter the Doc Status values required below.",
                anoptionaldocumentnumberthatcouldbeassignedtoadocument: "An optional document number that could be assigned to a document, for example engineering documents with a work breakdown structure code.",
                ifversionednoteswhetherdraftofreleased: "If versioned, notes whether Draft or Release.",
                thisisarecordofadocumentonly: "This is a record of a document only and has no underlying electronic file.",
                issomebodyworkingonadoc: "Is somebody working on the doc at the moment.",
                ifthisdochasaparentdoc: "If this doc has a parent doc, eg email for an attachment.",
                thextensionoftheunderlyingfile: "The extension of the underlying file. Can be used to lookup the ApplicationExtension.",                
                goodforseeingwhodeletedadoc: "Good for seeing who deleted a doc.",
                generatedcodeusetoidentifyexisting: "Generated code used to identify existing copies of the exact same document.",
                nullifnotcheckedoutuseridofusertowhichdoc: "Null if not checked out, User ID of User to which doc is checked out.",
                nullifnotcheckedoutdatetimeofcheckoutif: "Null if not checked out, date/time of checkout if checked out.",
                holdsthetemplate: "Holds the template.",
                holdsakeythatmightberequiredtoauthenticationa: "Hold a key that might be required to authenticate a document recipient before the recipient is able to open the doc.",
                doesthisdocumenthaveaccesscontrolset: "Does this document have Access Controls set?",
                doesthisdocumenthaveanyusercomment: "Does this document have any user comments?",
                storesageolocationrelevanttothedocument: "Stores a geo location relevant to a document. Could be assigned by Save or via API save.",
                opencloseallfolders: "Open/close all folders",
                hasnoaccesstoalibrarylistitemfolder: "Has no access to a Library / List Item / Folder",
                viewlibrarylistitemfolderdocument: "View Library / List Item / Folder / Documents",
                previewdocument: "Preview�documents",
                viewdocumentdetailshistory: "View document details / document history",
                updatedocumentdetails: "Update document details",
                downloaddocument: "Download document",
                checkoutandopendocument: "Check Out and Open document",
                opendocumentreadonly: "Open document Read Only",
                newdocumentuseastemplate: "New document (Use as Template)",
                addnewdocuments: "Add New documents",
                savedocuments: "Save documents",
                savenewversionofdocument: "Save New Version of document",
                sharedocuments: "Share Documents",
                sharelinktodocuments: "Share Link to documents",
                exportdetails: "Export Details",
                copymovedocuments: "Copy/Move documents",
                bulkdownloaddocuments: "Bulk Download documents",
                replacedocuments: "Replace documents",
                modifyfieldvalue: "Modify Field value",
                checkinoutdocuments: "Check In / Check Out documents",
                deletedocuments: "Delete documents",
                deletelibrarieslistitemsandfolders: "Delete Libraries, List Items and Folders",
                purgedocuments: "Purge documents",
                createupdateanddeletefolders: "Create, update and delete folders",
                setfolderaccesscontrol: "Set folder access control",
                //personrolehelp1: "Non-User/Disabled: No access to fileplan or documents and not counted against the licence count for this instance. Often assigned to users who are no longer active within fileplan but who are needed to preserve historical records of activity.",
                //personrolehelp2: "Guest: Lowest level of access. Can view documents but cannot edit them or upload new documents. Guests also have restricted access to fileplan functions. Often used to allow customers and suppliers to have controlled access to specific folders.",
                //personrolehelp3: "User: Most common level of access. Can upload and edit documents but cannot perform fileplan administration activities.",
                //personrolehelp4: "Administrator: Has all the permissions of a User but can also perform administration activities like making libraries, lists and adding people.",
                //personrolehelp5: "Instance Administrator: An Administrator who also has permission to manage the fileplan subscription.",
                secureddownloadlinks: "Secured Download Links",
                publicdownloadlinks: "Public Download Links",
                clickthebuttonbelowtogeneratetolinksallowinganybody: "Click the button below to generate links allowing anybody to download the selected documents. Use this option to make documents accesible from websites and other public content.",
                publiclinkwillwork: "Public Link Will Work",
                generatelinks: "Generate Links",
                emailasattachment: "Email as Attachment",
                emailaslink: "Email as Link",
                deletedocumentsandfolders: "Delete documents and folders",
                deleteonlydocumentsfolderswillnotbedeleted: "Delete only documents, folders will not be deleted",
                settodefault: "Set to default",
                ticktheboxafteryoucompleteeachstep: "Tick the box after you complete each step.",
                tiplookatthisiconfortipandtricks: "Look for this icon for tips and tricks you can apply in using and administering fileplan.",
                tickthefieldstoappearascolumns: "Tick the fields to appear as columns in the results grid for all users. Column order can be changed for all users by dragging the columns in the results grid then clicking the Save icon. Alternatively drag the fields below to the desired left to right order.",
                clicktosavecolumnorderforallusers: "Click to save column order (for all users).",
                thisiconindicateslinksto1: "This icon indicates links to video turorial and how to guides. ",
                thisiconindicateslinksto2: "This icon indicates links to detailed information in the fileplan Knowledge Base. ",
                thisiconindicateslinksto3: "This icon indicates links to 'Try it Now'. Click to leave the Setup Guide and apply what you have learnt in your own fileplan instance. ",
                usingthisguide: "Using this Guide",
                assignadateandtimetodocumentsseparatefromthecreationdate: "Assign a date and time to documents, separate from the Creation Date and Last Modified Date. For example, a paper contract dated 12 October 2013 is scanned and saved on 3 July 2015 and you wish to record the date shown on the document itself. A list of documents can be sorted by this field.",
                assignafinancialorcalendaryeartoadocument: "Assign a financial or calendar year to a document. Record years in any required format eg 2015, CY2015, FY2015 etc. Enter the Year values required below.",
                assignatimeperiodtoadocumentperiodscouldbedays: "Assign a time period to a document. Periods could be days, weeks, months, quarters, years or seasons. Examples of time periods could be FY2015Q2, 2015 Week 5, July, Monday or Winter. Enter the Period values required below.",
                thedocumentstitle: "The document's title. Every document must have a title. If a document is exported then the title becomes the document's filename.",
                thepersonthatistheauthorofthedocument: "The person that is the author of the document. This could be different to the person that creates or modifies the document. The Author list comes from the list of People.",
                thepersonthatisresponsibleforthe: "The person that is responsible for the content of the document. This could be different to the person that creates or modifies the document. The Responsible Person list comes from the list of People.",
                holdsahyperlinkthatrelatestoadocument: "Holds a hyperlink that relates to a document.",
                allowsalocationtobeassignedtoadocument: "Allows a Location to be assigned to a document. For example Locations could be Country, State/Postcode, Statistical Area, an address etc. Enter the Location values required below.",
                thedatethedocwasarchivedorisdue: "The date the doc was archived or is due to be archived.",
                thedatethedocumentwasdestroyedorisdue: "The date the document was destroyed or is due to be destroyed.",
                thedoctypeofthedocumentvaluescanbemodifiedbytheadmin: "The doc type of the document. Values can be modified by the Admin.",
                assignanindexvaluetoadocument: "Assign an Index value to a document. Enter the Index values required below.",
                ayesnofieldsuseinlegalenvironmentsdiscoverable: "A yes/no field used in legal environments to denote if a document is considered to be discoverable.",
                ayesnofieldsuseinlegalenvironmentsprivileged: "A yes/no field used in legal environments to denote if a document is considered to be privileged.",
                afieldusedinlegalenvironmentstodenoteifadocumentpriviledged: "A field used in legal environments to denote if a document is considered to be privileged.",
                allowslongnotestoberecordedaboutadocument: "Allows long notes to be recorded about a document.",
                enteracurrencyamountapplicabletothedocument: "Enter a currency amount applicable to the document. For example, an invoice total.",
                fordocumentssavedautomaticallybythefileplandocumentimporter: "For documents saved automatically by the fileplan Document Importer, the file path from where the document originated is recorded in this field.",
                thedatethedocumentwaslastreviewed: "The date the document was last reviewed.",
                thepersonthatlastreviewedthecontentofthedocument: "The person that last reviewed the content of the document. This could be different to the person that last modified the document. This Last Reviewed Person list comes from the People list.",
                thedatethedocumentisnextdueforreview: "The date the document is next due for review",
                thepersonthatwillnextreviewthecontentofthedocument: "The person that will next review the content of the document. This Last Reviewed Person list comes from the People list.",
                thepersonthatisresponsibletonexttakeactiononthedocument: "The person that is responsible to next take action on the document. The Assigned To list comes from the People list.",
                thesourcedocumentnumberfordocumentsthatcomefromanexternalorganisation: "The source document number for documents that come from an external organisation with their own document control system.",
                ayesnofieldthatrecordsthestatusofadocumentasapprovedtopublish: "A yes/no field that records the status of a document as approved to publish on a website, or other medium.",
                afolderstructurecanbecreatedandmaintained: "A folder structure can be created and maintained directly under the Library itself.",
                pricing: "Pricing",
                everyfeatureincludedinonesimplemonthlyprice: "Every feature included in one simple monthly price",
            }
        },
        supportedLocales: ['en-US', 'en-AU', 'am']
        //supportedLocales: []
    };
});
